import * as PIXI from "pixi.js";
import Layers from "../layers/Layers";
import { Coord } from "../types/Interface";
import genCoordFromAngle from "../utils/coord/genCoordFromAngle";
import calcCounterClockwise from "../utils/math/calcCounterClockwise";

interface ArcDetailsProps {
  color: number,
  lWidth: number
}

interface ArcProps extends ArcDetailsProps {
  autoRemove: boolean,
  hasCenterPoint: boolean
}

export default class Arc extends PIXI.Graphics {
  private Layers = Layers.getInstance();
  private color = 0x000000;
  private lWidth = 3;
  private center: Coord;
  private autoRemove: boolean = true;
  private hasCenterPoint = false;

  constructor(Props:ArcProps) {
    super();
    Object.assign(this, Props);
    this.addToLayer();

  }
  addToLayer = () => this.Layers.Middle.addChild(this);
  setDetails = (details: ArcDetailsProps) => Object.assign(this, details);
  draw(center: Coord, radius: number, startRad: number, currRad: number) {
    const isClockwise = calcCounterClockwise(currRad, startRad);
    const startCoord = genCoordFromAngle(startRad, radius);
    this.autoRemove && this.clear();
    this.center !== center && this.hasCenterPoint && this .circle(center.x, center.y, 5).fill(this.color)
    this
      .moveTo(center.x + startCoord.x, center.y + startCoord.y)
      .arc(center.x, center.y, radius, startRad, currRad, isClockwise)
      .stroke({ width: this.lWidth, color: this.color });
    
    this.center = center;
  }
}